var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.517 18.09a6.462 6.462 0 0 1-6.455-6.454A6.462 6.462 0 0 1 8.517 5.18a6.462 6.462 0 0 1 6.455 6.455 6.462 6.462 0 0 1-6.455 6.455M18.44.863l-3.95.194a.52.52 0 0 0-.495.519h0c0 .3.253.537.552.518l2.63-.163-3.904 3.903a7.445 7.445 0 0 0-4.756-1.7c-2.004 0-3.888.78-5.304 2.197a7.453 7.453 0 0 0-2.198 5.305c0 2.004.78 3.888 2.198 5.304a7.453 7.453 0 0 0 5.304 2.198c2.004 0 3.888-.78 5.305-2.198a7.453 7.453 0 0 0 2.197-5.304 7.448 7.448 0 0 0-1.985-5.083l3.882-3.882-.163 2.63a.52.52 0 1 0 1.037.057l.194-3.951a.52.52 0 0 0-.544-.544",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.87c6b5219503384848455cdaeb5cffba.svg";
export { ForwardRef as ReactComponent };